
<div id="app" class="fullWidth m-auto">
  <transition name="fade">
    <RouterView />
  </transition>
</div>
